import { isDefined } from '@sgme/fp';
import type { ColTypeDef, ValueFormatterParams } from 'ag-grid-community';
import { useSPIntl } from 'hooks/useIntl';
import { useMemo } from 'react';
import type { IntlShape } from 'react-intl';

import { defaultFilterOptions } from './utils';

export function usePercentColumnType<T>(
  precision: number,
  filterOptions: string[] = defaultFilterOptions,
): ColTypeDef<T> {
  const { formatNumber } = useSPIntl();
  return useMemo<ColTypeDef<T>>(
    () => ({
      valueFormatter: ({ value }: ValueFormatterParams) => formatToPercent(value, precision, formatNumber),
      filter: 'agNumberColumnFilter',
      filterParams: {
        filterOptions,
      },
      cellClass: 'ag-right-aligned-cell',
    }),
    [filterOptions, formatNumber, precision],
  );
}

export function formatToPercent(
  value: number | bigint | null | undefined,
  precision: number,
  formatNumber: IntlShape['formatNumber'],
) {
  return isDefined(value)
    ? formatNumber(value, {
        maximumFractionDigits: precision,
      }).concat(' %')
    : '';
}

export function useServerSidePercentColumnType<T>(precision: number): ColTypeDef<T> {
  const { formatNumber } = useSPIntl();
  return useMemo<ColTypeDef<T>>(
    () => ({
      valueFormatter: ({ value }: ValueFormatterParams) => formatToPercent(value, precision, formatNumber),
      cellClass: 'ag-right-aligned-cell',
    }),
    [formatNumber, precision],
  );
}
